import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=64db0d3f&scoped=true"
import script from "./reset.vue?vue&type=script&lang=js"
export * from "./reset.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/login.css?vue&type=style&index=0&id=64db0d3f&prod&scoped=true&lang=css&external"
import style1 from "./reset.vue?vue&type=style&index=1&id=64db0d3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db0d3f",
  null
  
)

export default component.exports